const categories = [
    {label: "en_US",value: "English (US)"},
    {label: "hi",value: "Hindi"},
    {label: "es",value: "Spanish"},
    {label: "fr",value: "French"},
    {label: "ru",value: "Russian"},
    {label: "en_GB",value: "English (UK)"},
    {label: "de",value: "German"},
    {label: "it",value: "Italian"},
    {label: "ko",value: "Korean"},
    {label: "pt-BR",value: "Brazilian Portuguese"},
    {label: "ar",value: "Arabic"},
    {label: "tr",value: "Turkish"},
]
export default categories;
// hi	Hindi
// es	Spanish
// fr	French
// ja	Japanese
// ru	Russian
// en_GB	English (UK)
// de	German
// it	Italian
// ko	Korean
// pt-BR	Brazilian Portuguese
// ar	Arabic
// tr	Turkish